import './footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="copyright">
          <span>&copy; Copyright 2022</span>
          <span>All right reserved</span>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
